import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Pane } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekPaneSet } from "./RecekPaneSet";
import NavComponent from "./NavComponent";
export var PublisherDataRequired = function (_a) {
    var _b = _a.showNavigation, showNavigation = _b === void 0 ? false : _b;
    var formatMessage = useIntl().formatMessage;
    var history = useHistory();
    var handleRedirectToPublisher = function () {
        history.push("/brpublishers/my-publisher");
    };
    var content = (React.createElement("div", { style: { padding: "20px", textAlign: "center" } },
        React.createElement("h2", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.error.publisher.dataConfirmationRequired" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.error.publisher.dataConfirmationRequired.description" })),
        React.createElement(Button, { buttonStyle: "primary", onClick: handleRedirectToPublisher },
            React.createElement(FormattedMessage, { id: "ui-br-agency.error.publisher.dataConfirmationRequired.button" }))));
    if (!showNavigation) {
        return content;
    }
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-agency.pane.title.navigation",
            }) },
            React.createElement(NavComponent, null)),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-agency.error.publisher.dataConfirmationRequired",
            }) }, content)));
};
